import type { StageState } from './statusMap.js';

const STAGE_LABELS = ['Spec', 'Build', 'PR review', 'Merge', 'Deploy'];

type StepStatus = StageState | 'pending';

function stepStatus(index: number, stage: number, stageState: StageState): StepStatus {
  if (index < stage) return 'done';
  if (index === stage) return stageState;
  return 'pending';
}

export default function PipelineStepper({
  stage,
  stageState,
  timeLabel,
  slow,
  className,
}: {
  stage: number;
  stageState: StageState;
  timeLabel?: string;
  slow?: boolean;
  className?: string;
}) {
  return (
    <div className={`pipeline-stepper${className ? ` ${className}` : ''}`}>
      <div className="pipeline-steps">
        {STAGE_LABELS.map((label, i) => {
          const status = stepStatus(i, stage, stageState);
          return (
            <div key={label} style={{ display: 'contents' }}>
              {i > 0 && (
                <span
                  className="pipeline-connector"
                  data-status={stepStatus(i - 1, stage, stageState) === 'done' ? 'done' : 'pending'}
                />
              )}
              <div className="pipeline-step" data-status={status}>
                <span className="pipeline-dot" data-status={status} />
                <span className="pipeline-label">{label}</span>
              </div>
            </div>
          );
        })}
      </div>
      {timeLabel && (
        <span className={`pipeline-time${slow ? ' pipeline-time-slow' : ''}`}>{timeLabel}</span>
      )}
    </div>
  );
}
